import { render, staticRenderFns } from "./M2hPdf.vue?vue&type=template&id=9f4963d6&scoped=true&"
import script from "./M2hPdf.vue?vue&type=script&lang=js&"
export * from "./M2hPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4963d6",
  null
  
)

export default component.exports